// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3_RU4","colMin":"styles_colMin__1PBpi","colCheckbox":"styles_colCheckbox__2eOp9"};